function videoHerospaceSlider() {
  $(document).ready(function() {
    if ($('#video_herospace_slider').length) {
      var splideSlider = new Splide('#video_herospace_slider', {
        type: 'fade',
        perPage: 1,
        focus: 'center',
        autoplay: true,
        interval: 10000,
        pauseOnHover: false,
        pauseOnFocus: false,
        arrows: false,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        rewind: true,
        label: 'Video herospace slider',
        labelledby: 'Video herospace slider',
        role: 'banner',
        pager: true,
        draggable: true,
      });

      splideSlider.on('active', function (slide) {

        // stop all videos
        document.querySelectorAll('#video_herospace_slider video').forEach(video => {
          video.pause();
          video.currentTime = 0;
        });

        // start video of current slide
        var activeVideo = slide.slide.querySelector('video');

        if (activeVideo) {
          activeVideo.currentTime = 0;
          activeVideo.play().catch(() => {});
        }

      });

      splideSlider.mount();
    }
  });
}
